import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useRef, useState} from "react";
import {ButtonGroup, Card, CardContent, Chip} from "@mui/material";
import ContextSearchNavbar from "../navbars/ContextSearchNavbar";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import MDBox from "../../components/MDBox";
import Footer from "../Footer";
import {
  cancelInventoryEvent,
  cancelInventoryEventAll,
  cancelInventoryEventAllFuture,
  getEventReservations,
  getInventoryEventFull,
  saveCustomerInventoryEventRegistration
} from "../common/api/InventoryApi";
import {Link, useNavigate, useParams} from "react-router-dom";
import MDTypography from "../../components/MDTypography";
import Grid from "@mui/material/Grid";
import MDButton from "../../components/MDButton";
import Divider from "@mui/material/Divider";
import {Col, Row} from "react-bootstrap";
import {
  displayAgeRange,
  displayDay,
  displayDuration,
  formatAge,
  formatCurrency,
  formatDate,
  formatDateMask,
  formatDateTime,
  inventoryAvailable
} from "../common/Utils";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import NotificationItem from "../Items/NotificationItem";
import ListCustomersModal from "../client/ListCustomersModal";
import {
  cancelClientReservation,
  cancelClientWaitlist,
  checkOutClientReservation,
  deleteInventoryNote,
  getCustomer,
  getCustomerPurchaseGroupResponse,
  getInventoryNotes,
  noShowClientReservation,
  recordCustomerVisit,
  saveEventNote,
  saveMoveEventReservation
} from "../common/api/WebApi";
import ClientViewCustomerCartModal from "../common/ClientViewCustomerCartModal";
import ManageInventoryEventModal from "./ManageInventoryEventModal";
import Confirm from "../common/Confirm";
import {CONSTANTS} from "../common/constants";
import {addClientToWaitlist} from "../common/api/CartApi";
import Avatar from "@mui/material/Avatar";
import ClientViewEventRegistrationModal from "./modal/ClientViewEventRegistrationModal";
import EventNoteModal from "./EventNoteModal";
import PageLoading from "../common/PageLoading";
import CartFinal from "../common/cart/CartFinal";
import RegisterEventModal from "./modal/RegisterEventModal";
import EventGuests from "./pane/EventGuests";
import ActiveMember from "../common/ActiveMember";
import FormSubmission from "./FormSubmission";
import Button from "@mui/material/Button";
import PopupState, {bindMenu, bindTrigger} from "material-ui-popup-state";
import NoteFlagsModal from "../common/NoteFlagsModal";
import Audit from "../common/Audit";
import ClientLookupEventsModal from "../client/ClientLookupEventsModal";
import ActionItem from "../action/ActionItem";

export default function ViewInventoryEvent(props) {

  const navigate = useNavigate();
  const [context, setContext] = useContext(AppContext);
  let {guid} = useParams();

  const [event, setEvent] = useState();
  const [refreshEvent, setRefreshEvent] = useState(false);
  const [inventory, setInventory] = useState();
  const [modalInventory, setModalInventory] = useState();
  const [sessionEventInventory, setSessionEventInventory] = useState();

  const [publicEventUrl, setPublicEventUrl] = useState();
  const [isTemplate, setIsTemplate] = useState(false);

  useEffect(() => {
    setIsTemplate(inventory?.eventTemplate);
  }, [inventory?.eventTemplate]);

  const clientFlags = (clientNotes) => {
    let hasFlags = false;
    inventoryNotes?.map((a, b) => {
      if (a.noteFlag) {
        hasFlags = true;
      }
    })
    return hasFlags;
  }

  const [inventoryReady, setInventoryReady] = useState(false);
  const [renderIndex, setRenderIndex] = useState(1);

  const [refreshCart, setRefreshCart] = useState(false);
  const [reservation, setReservation] = useState();

  const [viewingCart, setViewingCart] = useState(false);
  const [saving, setSaving] = useState(false);
  const [manageInventoryEvent, setManageInventoryEvent] = useState(false);
  const [manageInventorySessionEvent, setManageInventorySessionEvent] = useState(false);

  const [showRegistrationInventory, setShowRegistrationInventory] = useState(false);
  const [showMoveRegistration, setShowMoveRegistration] = useState(false);

  const [client, setClient] = useState(null);
  const [showCancelEvent, setShowCancelEvent] = useState(false);
  const [cancelActing, setCancelActing] = useState(false);

  const [confirmation, setConfirmation] = useState({});

  const [savingCancelEvent, setSavingCancelEvent] = useState(false);

  const [reservationTabActive, setReservationTabActive] = useState('active');

  const [modalActive, setModalActive] = useState(false);
  const [addNote, setAddNote] = useState(false);
  const [searchNotes, setSearchNotes] = useState(null);
  const [note, setNote] = useState({});
  const [manageNote, setManageNote] = useState(null);
  const [noteCount, setNoteCount] = useState(0);
  const [clientDisabled, setClientDisabled] = useState(false);
  const [inventoryNotes, setInventoryNotes] = useState(null);
  const [showFlags, setShowFlags] = useState(false);

  const toggleFlags = () => {
    setShowFlags(true);
  }

  const highlight = (haystack) => {
    const needle = searchNotes;
    if (!needle) {
      return haystack;
    }
    var querystr = needle;
    var result = haystack;
    var reg = new RegExp(querystr.split(' ').join('|'), 'gi');
    var final_str = result.replace(reg, function (str) {
      return '<b>' + str + '</b>'
    });

    return final_str;

  }

  const getInventoryNotesFn = async () => {
    return await getInventoryNotes(guid);
  }

  useEffect(() => {
    if (!inventory?.guid) {
      return;
    }
    getInventoryNotesFn().then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setInventoryNotes(result);
      }
    });
  }, [inventory?.guid, noteCount]);

  const matchNotes = (note) => {
    let notes = searchNotes.split(' ');
    let match = true;
    notes.forEach(n => {
      if (!note.note.toLowerCase().includes(n.toLowerCase())) {
        match = false;
      }
    });
    return match;
  }

  const addNoteFn = () => {
    setAddNote(true);
    setNote(null);
  };

  const manageNoteFn = (note) => {
    setNote(note);
    setManageNote(true);
  };

  const handleSaveNote = async (note) => {

    setSaving(true);
    note.inventoryGuid = inventory.guid;

    let result = await saveEventNote(note);
    setSaving(false);
    setAddNote(false);
    setManageNote(false);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setNoteCount(noteCount + 1);
    }
  }

  const handleMoveReservation = async (event) => {

    setSaving(true);

    let r = {
      reservation: reservation,
      event: event
    }

    let result = await saveMoveEventReservation(r);
    setSaving(false);
    setRefreshEvent(true);

    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setShowMoveRegistration(false);
      setReservation(null);
      setClient(null);
    }
  }

  const myRefs = useRef([]);

  const preCancelEvent = async (guid, future) => {
    setCancelActing(true);
    return getEventReservations(guid, future).then((resp) => {
      setCancelActing(false);
      return resp;
    })
  }


  const cancelInventoryEventFn = (guid) => {

    let message = <p>Are you sure you want to cancel this event?</p>;
    let htmlMessage = null;
    getEventReservations(guid, false).then((resp) => {

      if (resp?.reservationCount > 0) {
        htmlMessage = <p><b>{resp.reservationCount}</b> reservations will be affected.</p>
      }
      setCancelAll(false);
      setConfirmation({
        title: 'Cancel Event',
        message: message,
        htmlMessage: htmlMessage
      })
      setShowCancelEvent(true);
      setSavingCancelEvent(false);
    });
  };

  const archiveInventoryEventTemplateFn = () => {
    setCancelAll(false);
    setConfirmation({
      title: 'Archive Event Template',
      message: 'Are you sure you want to archive this template?'
    })
    setShowCancelEvent(true);
    setSavingCancelEvent(false);
  };

  const copyToClipboard = () => {
    let copyText = document.getElementById("copyElement");
    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices
    navigator.clipboard.writeText(copyText.value);
    let _context = {...context};
    _context.toast = {
      message: 'Copied to clipboard',
    }
    setContext({..._context});
  }

  const cancelAllInventoryEventFn = (guid) => {
    let htmlMessage = null;
    let message = 'You are cancelling an event series. Are you sure you want to cancel all events in series?'

    preCancelEvent(guid, true).then((resp) => {
      if (resp?.reservationCount > 0) {
        htmlMessage = <p><b>{resp.reservationCount}</b> reservations will be affected.</p>
      }
      setCancelAll(true);
      setCancelAllFuture(false);
      setConfirmation({
        title: 'Cancel All Events',
        message: message,
        htmlMessage: htmlMessage
      })

      setShowCancelEvent(true);
      setSavingCancelEvent(false);

    });
  };

  const cancelAllFutureInventoryEventFn = (guid) => {
    let htmlMessage = null;
    let message = 'You are cancelling an event series. Are you sure you want to cancel all future events in series?'

    preCancelEvent(guid, true).then((resp) => {
      if (resp?.reservationCount > 0) {
        htmlMessage = <p><b>{resp.reservationCount}</b> reservations will be affected.</p>
      }
      setCancelAll(true);
      setCancelAllFuture(true);
      setConfirmation({
        title: 'Cancel All Future Events',
        message: message,
        htmlMessage: htmlMessage
      })

      setShowCancelEvent(true);
      setSavingCancelEvent(false);

    });

  };

  const [listCustomersModalOpen, setListCustomersModalOpen] = useState(false);
  const [listCustomersWaitlistModalOpen, setListCustomersWaitlistModalOpen] = useState(false);


  const handleCloseNote = () => {
    setManageNote(false);
    setAddNote(false);
  }

  const [cancelAll, setCancelAll] = useState(false);
  const [cancelAllFuture, setCancelAllFuture] = useState(false);

  const handleCancelSwitch = () => {
    if (cancelAll) {
      if (cancelAllFuture) {
        handleAllFutureEventsCancel();
      } else {
        handleAllEventsCancel();
      }
    } else {
      handleEventCancel();
    }
  }

  const handleEventCancel = () => {
    setSavingCancelEvent(true);
    cancelInventoryEvent(inventory).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setRefreshEvent(true);
        setShowCancelEvent(false);
        setSavingCancelEvent(false);
        if (isTemplate) {
          navigate('/templates/event-templates');
        } else {
          navigate('/sales/events');
        }
      }
    });
  }

  const handleAllEventsCancel = () => {
    setSavingCancelEvent(true);
    cancelInventoryEventAll(inventory).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setRefreshEvent(true);
        setShowCancelEvent(false);
        setSavingCancelEvent(false);
        navigate('/sales/events');
      }
    });
  }

  const handleAllFutureEventsCancel = () => {
    setSavingCancelEvent(true);
    cancelInventoryEventAllFuture(inventory).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        setRefreshEvent(true);
        setShowCancelEvent(false);
        setSavingCancelEvent(false);
        navigate('/sales/events');
      }
    });
  }

  const handleCloseConfirm = () => {
    setShowCancelEvent(false);
    setSavingCancelEvent(false);
  }

  const handleCloseListCustomersModal = () => {
    setListCustomersModalOpen(false);
  }

  const handleCloseListWaitlistCustomersModal = () => {
    setListCustomersWaitlistModalOpen(false);
  }

  const handleCloseInventoryEventModal = () => {
    setManageInventoryEvent(false);
  }

  const closeInventoryFn = () => {
    setManageInventoryEvent(false);
    setModalInventory(null);
  }

  const handleSaveInventory = (inventory) => {
    closeInventoryFn();
    setRefreshEvent(true);
  }

  const startAddCustomerReservation = () => {
    setListCustomersModalOpen(true);
  }

  const startAddCustomerWaitlist = () => {
    setListCustomersWaitlistModalOpen(true);
  }

  const getEventFn = async (guid) => {
    return await getInventoryEventFull(guid);
  }
  const refHandler = (index) => {
    myRefs.current[index].visible = !!!myRefs.current[index].visible;
    setRenderIndex(renderIndex + 1);
  };

  const [actionItem, setActionItem] = useState(null);
  const [actionItemActive, setActionItemActive] = useState(false);
  const [actionRecipients, setActionRecipients] = useState([]);

  const toActionUsers = () => {
    let actionReservations = [];
    if (reservationTabActive === 'active') {
      actionReservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CHECKED_IN && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CANCELLED && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.NO_SHOW);
    } else if (reservationTabActive === 'checkedin') {
      actionReservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN);
    } else if (reservationTabActive === 'cancelled') {
      actionReservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CANCELLED);
    } else if (reservationTabActive === 'noshow') {
      actionReservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.NO_SHOW);
    }
    let memberGuids = [];
    let actionUsers = [];
    for (let j in actionReservations) {
      if (memberGuids.indexOf(actionReservations[j].member?.guid) === -1) {
        memberGuids.push(actionReservations[j].member?.guid);
        actionUsers.push(actionReservations[j].member);
      }
    }
    setActionRecipients(actionUsers);
  }

  const startAddTags = () => {
    setActionItem('addTags');
    setActionItemActive(true);
    toActionUsers();
  }
  const startComposeEmail = () => {
    setActionItem('composeEmail');
    setActionItemActive(true);
    toActionUsers();
  }

  const toWaitlistActionUsers = () => {
    let memberGuids = [];
    let actionUsers = [];
    for (let j in inventory?.waitlist) {
      if (memberGuids.indexOf(inventory?.waitlist[j].member?.guid) === -1) {
        memberGuids.push(inventory?.waitlist[j].member?.guid);
        actionUsers.push(inventory?.waitlist[j].member);
      }
    }
    setActionRecipients(actionUsers);
  }

  const startWaitlistAddTags = () => {
    setActionItem('addTags');
    setActionItemActive(true);
    toWaitlistActionUsers();
  }

  const startComposeWaitlistEmail = () => {
    setActionItem('composeEmail');
    setActionItemActive(true);
    toWaitlistActionUsers();
  }

  const toggleCartFn = () => {
    setViewingCart(!viewingCart);
  }

  const [cartActive, setCartActive] = useState(false);

  const viewCustomerCart = () => {
    setCartActive(true);
  }

  const cartCallback = (callback) => {
    if (callback.action === 'close') {
      setCartActive(false);
    }
    if (callback.action === 'reload') {
      setRefreshCart(true);
      setRefreshEvent(true);
    }
    if (callback.action === 'success') {
      setCartActive(false);
      setRefreshCart(true);
      setRefreshEvent(true);
      let _context = {...context};
      _context.toast = {
        message: 'Registration Successful',
      }
      setContext({..._context});
    }
  }

  const toggleCheckout = (_client) => {
    setClient(_client?.member);
    setViewingCart(true);
    setRefreshCart(true);
    toggleReservationsCartFn();
  }

  const toggleReservationsCartFn = () => {
    setShowRegistrationInventory(!showRegistrationInventory);
  }

  const [showRegisterEvent, setShowRegisterEvent] = useState(false);

  const handleAssignInventory = (client) => {
    setClient(client);
    setListCustomersModalOpen(false);
    setShowRegisterEvent(true);
  }

  const handleAssignWaitlist = (client) => {

    addClientToWaitlist(inventory, client.guid).then(result => {
      setRefreshEvent(true);
      setListCustomersWaitlistModalOpen(false);
      let c = {...context}
      c.toast = {message: 'Added to wait list', type: 'success'};
      setContext(c);
    });

  }

  const [salesReady, setSalesReady] = useState(false);
  const [salesResp, setSalesResp] = useState();
  const [searchTimer, setSearchTimer] = useState(1);
  const [paymentId, setPaymentId] = useState();

  useEffect(() => {
    const timer = setTimeout(() => {
      if (paymentId) {
        if (searchTimer > 1) {
          if (searchTimer < 30) {
            getSalesFn(paymentId);
          }
        }
      }
    }, 1000);
    return () => clearTimeout(searchTimer);
  }, [searchTimer]);

  const getSalesFn = async (paymentId) => {
    let result = await getCustomerPurchaseGroupResponse(client?.guid, paymentId);
    if (result) {
      if (result?.salesItems?.length > 0) {
        setSalesResp(result);
        setSalesReady(true);
        setRefreshCart(true);
        setRefreshEvent(true);
        toggleCartFn();
      } else {
        setSearchTimer(searchTimer + 1);
      }
    }
  }

  const handleCheckout = (response) => {
    if (response && response?.paymentId) {
      setPaymentId(response?.paymentId);
      getSalesFn(response?.paymentId);
    } else {
      setRefreshCart(true);
      setRefreshEvent(true);
      toggleCartFn();
    }
  };

  const handleEditInventory = () => {
    let _inventory = {...inventory};
    _inventory.event = event;
    setModalInventory(_inventory);
    setManageInventoryEvent(true);
  }

  const handleEditRecurringInventory = () => {
    let _inventory = {...inventory};
    _inventory.event = event;
    _inventory.manageRecurring = true;
    setModalInventory(_inventory);
    setManageInventoryEvent(true);
  }

  const createSessionEvent = () => {
    let parentSessionGuid = inventory?.parentEventGuid || inventory?.guid;
    let _inventory = {...inventory};
    _inventory.parentEventGuid = parentSessionGuid;
    _inventory.guid = null;
    _inventory.id = null;
    _inventory.createSessionEventInSeries = true;

    setSessionEventInventory(_inventory);
    setManageInventorySessionEvent(true);

  }


  useEffect(() => {
    if (!guid) {
      return;
    }
    setInventoryReady(false);
    getEventFn(guid).then(result => {
      setInventory(null);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let e = {...result};
        e.eventDate = new Date(e.eventDate);
        e.eventEndDate = new Date(e.eventEndDate);

        setInventory(e);
        setInventoryReady(true);

        setPublicEventUrl(getEventDirectPortalLink(e, context?.sessionUser?.company));

      }
    });

  }, [guid]);

  useEffect(() => {
    if (!guid) {
      return;
    }
    if (!refreshEvent) {
      return;
    }
    setRefreshEvent(false);

    getEventFn(guid).then(result => {
      setInventory(null);
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        let e = {...result};
        e.eventDate = new Date(e.eventDate);
        e.eventEndDate = new Date(e.eventEndDate);

        setInventory(e);
        setInventoryReady(true);
      }
    });
  }, [refreshEvent]);

  useEffect(() => {
    if (inventory) {
      handleReservationsCounts();
    }
  }, [inventory])


  const recordVisitFn = async (event, reservation) => {

    if (reservation.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.WALKIN_WAIVER) {
      getCustomer(reservation.memberGuid).then((resp) => {
        handleAssignInventory(resp);
      });
      return;
    }

    reservation.saving = true;
    let result = await recordCustomerVisit(reservation.memberGuid, reservation);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setRefreshEvent(true);
    }
  }

  const startSearchInventory = (reservation) => {
    let _reservation = {...reservation};
    _reservation.event = inventory;
    _reservation.parentEventGuid = inventory.guid;
    setReservation(_reservation);
    setShowRegistrationInventory(true);
  }

  const startMoveReservation = (reservation) => {
    let _reservation = {...reservation};
    _reservation.event = inventory;
    _reservation.parentEventGuid = inventory.guid;
    setReservation(_reservation);
    setClient(_reservation?.member);
    setShowMoveRegistration(true);
  }

  const undoCheckinFn = async (reservation) => {
    reservation.cancelling = true;
    checkOutClientReservation(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshEvent(true);
      }
    });
  }
  const cancelReservationFn = async (reservation) => {
    reservation.cancelling = true;
    cancelClientReservation(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshEvent(true);
      }
    });
  }

  const noShowReservationFn = async (reservation) => {
    reservation.cancelling = true;
    noShowClientReservation(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshEvent(true);
      }
    });
  }

  const cancelWaitlistFn = async (reservation) => {
    reservation.cancelling = true;
    cancelClientWaitlist(reservation).then(result => {
      if (result.error) {
        setContext({...context, error: {message: result.message}});
      } else {
        reservation.cancelling = false;
        setRefreshEvent(true);
      }
    });
  }

  const confirmEventWaitlistRegistration = async (reservation) => {
    reservation.saving = true;
    saveCustomerInventoryEventRegistration(reservation).then(result => {
      getCustomer(reservation.memberGuid).then((resp)=> {
        if (result.error) {
          setContext({...context, error: {message: result.message}});
        } else {
          reservation.cancelling = false;
          setClient(resp);
          setRefreshCart(true);
          setCartActive(true);
        }
      });
    });
  }

  const reservationDisabled = (reservation) => {
    let id = reservation?.reservationStatus?.id;
    return id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN
      || id === CONSTANTS.RESERVATION_STATUS.CANCELLED
      || id === CONSTANTS.RESERVATION_STATUS.EVENT_CANCELLED;
  }

  const NoteItemActions = ({item}) => {
    return (<PopupState variant="popover" popupId={'inventory-popup-menu-' + item.id}>
      {(popupState) => (
        <>
          <span variant="contained" {...bindTrigger(popupState)}>
           <MDButton
             variant="outlined"
             color="secondary"
             size="small"
             circular
             iconOnly
           >
            <Icon>more_horiz</Icon>
          </MDButton>
          </span>
          <Menu {...bindMenu(popupState)}>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                manageNoteFn(item)
              }} icon={<Icon>edit</Icon>} title="Edit"/>
            <NotificationItem
              onClick={(e) => {
                popupState.close();
                archiveNoteFn(item)
              }} icon={<Icon>delete</Icon>} title="Archive"/>
          </Menu>
        </>
      )}
    </PopupState>);
  }

  const togglePinnedNote = (note, idx) => {
    note.pinned = !note.pinned;
    let _notes = [...inventoryNotes];
    inventoryNotes[idx] = note;
    setInventoryNotes(_notes);

    handleSaveNote(note).then(r => {

    });
  }

  const pinnedNote = (note) => {
    return note?.pinned ? true : false;
  }
  const [confirmDeleteNote, setConfirmDeleteNote] = useState(false);

  const handleConfirmDeleteNote = async (note) => {
    setSaving(true);
    let result = await deleteInventoryNote(note);
    setSaving(false);
    setConfirmation(null);
    if (result.error) {
      setContext({...context, error: {message: result.message}});
    } else {
      setNoteCount(noteCount + 1);
      setConfirmDeleteNote(false);
    }
  }

  const archiveNoteFn = (note) => {
    setNote(note);
    let confirmation = {
      title: 'Confirm Delete note?',
      message: 'Confirm delete note',
      entity: note
    }
    setConfirmation(confirmation);
    setConfirmDeleteNote(true);
  };

  const NoteItem = ({note, index}) => {
    return (<li
      className={'list-group-item hover-bg-soft ' + (searchNotes && !matchNotes(note) ? 'd-none' : '')}
      key={index}>
<span className="pull-right">
         <NoteItemActions item={note}/>
        </span>

      <p>
        {note?.familyNoteMember && <span
          className={"fst-italic"}
          dangerouslySetInnerHTML={{__html: highlight('(' + note?.familyNoteMember?.firstName + ' ' + note?.familyNoteMember?.lastName + ') ')}}/>
        }
        <span
          dangerouslySetInnerHTML={{__html: highlight(note.note)}}/>
      </p>
      <Chip
        onClick={() => {
          togglePinnedNote(note, index);
        }}
        label={<>
          {!note.pinned ?
            <span
              style={{
                transform: 'rotate(15deg)'
              }}
              className="font-color-grey fa fa-thumbtack"></span>
            :
            <span
              className="font-color-gold fa fa-thumbtack"></span>
          }</>}
        variant="outlined"
      />&nbsp;
      {note?.noteFlag && <><Chip
        label={<span
          className="font-color-gold fa fa-flag"></span>}
        variant="outlined"
      />
        &nbsp;</>
      }
      <Chip
        label={<>By: {note.createUser.firstName + ' ' + note.createUser.lastName} On: {formatDateTime(note.createDate)}</>}
        variant="outlined"
      />&nbsp;
      {note.reminderNote && <>
        <Chip
          label={<>Reminder Date: {formatDate(note.reminderDate)}</>}
          variant="outlined"
        />&nbsp;
      </>
      }
    </li>);
  }

  const DisplayAttendee = ({reservation}) => {
    let dob = '';
    if (reservation?.attendee?.familyMemberType === 1) {
      let age = formatAge(reservation.attendee);
      if (age?.length > 0) {
        dob = ' (' + age + ')';
      }
    }

    return <>
      {reservation?.member?.firstName}&nbsp;{reservation?.member?.lastName}
      {reservation?.attendee &&
        <>{' - ' + reservation?.attendee.firstName + ' ' + reservation?.attendee.lastName + dob}</>
      }
    </>
  }

  const PurchaseEntries = ({reservation}) => {
    return <>
      {reservation?.memberAccount && <>
        <Chip
          icon={<Icon>loyalty</Icon>}
          label={reservation?.memberAccount?.inventoryName}
          color="primary"
          size="medium"
        />&nbsp;
      </>}
      {reservation?.purchaseEntries?.length > 0 && <>
        {[...new Set(reservation?.purchaseEntries)]?.map((dc, idx) => {
          return (
            <span key={idx}>
                                          <Chip
                                            icon={<Icon>loyalty</Icon>}
                                            label={dc}
                                            color="primary"
                                            size="medium"
                                          />&nbsp;
                                        </span>
          )
        })
        }
      </>}
    </>
  }

  const getEventDirectPortalLink = (inventory, company) => {
    let portalUrl = company?.portalUrl || null;
    if (!portalUrl) {
      return null;
    }
    let endsWith = portalUrl.at(-1) === '/';
    let url = portalUrl + (endsWith ? '' : '/') + '#/cx/register/' + inventory.guid;

    return url;
  }

  const getPrintableReservations = () => {
    const cols = 3;


    let html = '<table style="border:solid 1px #ddd">' +
      '<thead><tr>' + //
      '<th>Guest</th>' + //
      '<th>Child</th>' + //
      '<th>Child Age</th>' + //
      // '<th>Special Request</th>' + //
      '</tr>' + //
      '</thead><tbody>';

    let reservations;
    if (reservationTabActive === 'active') {
      reservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CHECKED_IN && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CANCELLED && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.NO_SHOW);
    } else if (reservationTabActive === 'checkedin') {
      reservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN);
    } else if (reservationTabActive === 'cancelled') {
      reservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CANCELLED);
    } else if (reservationTabActive === 'noshow') {
      reservations = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.NO_SHOW);
    }
    if (!reservations || reservations.length === 0) {
      html += '<tr><td colspan="' + cols + '">There are no reservations for this status</td></tr>';
    }

    reservations.forEach(reservation => {
      let dob = '';
      if (reservation?.attendee?.familyMemberType === 1) {
        let age = formatAge(reservation.attendee);
        if (age?.length > 0) {
          dob = age;
        }
      }

      let rr = '<td>' + reservation?.member?.firstName + ' ' + reservation?.member?.lastName + '</td>';
      if (reservation?.attendee?.familyMemberType === 1) {
        rr += '<td>' + reservation?.attendee.firstName + ' ' + reservation?.attendee.lastName + '</td>';
        rr += '<td>' + dob + '</td>';
      } else {
        rr += '<td></td>';
        rr += '<td></td>';
      }
      // rr += '<td>' + (reservation.specialRequestInput || '') + '</td>';
      html += `<tr>${rr}</tr>`;
    });

    html += '</tbody></table>';
    return html;
  }

  const printReservationTab = () => {

    let html = '<h5>Event Reservations</h5><ul>';
    html += getPrintableReservations();
    html += '</ul>';
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
                                              <html>
                                              <head>
                                                  <title>Print</title>
                                                  <style>
                                                      body { font-family: Arial, sans-serif; padding: 20px; font-size:0.9rem; line-height:0.9rem; }
                                                      p, ul{margin:0; padding:0; line-height:13px; font-size:12px;}
                                                      ul {padding:0; margin: 0}
                                                      li {list-style:none}
                                                      h1,h2,h3,h4,h5,h6{font-size:14px; margin:0; padding:0; line-height:18px}
                                                      .no-print { display: none !important; }
                                                      table {width: 100%; text-align:left; border-collapse: collapse;}
                                                      td, tr, th {border: solid 1px #ccc; padding:4px;}
                                                      
                                                  </style>
                                              </head>
                                              <body>
                                                  <a href="javascript:window.print();javascript:window.close()" style="float:right">Print</a>
                                                   ${html}
                                              </body>
                                              </html>
                                            `);
    printWindow.document.close();

  }

  const [bookedReservations, setBookedReservations] = useState(0);
  const [checkedInReservations, setCheckedInReservations] = useState(0);
  const [cancelledReservations, setCancelledReservations] = useState(0);
  const [noShowReservations, setNoShowReservations] = useState(0);

  const handleReservationsCounts = () => {
    if (!inventory?.reservations) {
      return;
    }
    const booked = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CHECKED_IN && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CANCELLED && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.NO_SHOW).length;
    const checkedIn = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN).length;
    const cancelled = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CANCELLED).length;
    const noShowed = inventory?.reservations?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.NO_SHOW).length;
    setBookedReservations(booked);
    setCheckedInReservations(checkedIn);
    setCancelledReservations(cancelled);
    setNoShowReservations(noShowed);
  }

  const ReservationMeta = ({reservation}) => {
    return (
      <>
      <span style={{
        'clear': 'both',
        'display': 'block',
        'marginTop': '10px',
        'paddingBottom': '10px'
      }}>
                                <MDButton
                                  color={reservationDisabled(reservation) ? 'error' : 'info'}
                                  size="small"
                                  className={'pull-right'}
                                  disabled={reservationDisabled(reservation)}
                                  onClick={(e) => {
                                    recordVisitFn(e, reservation);
                                  }}>
                                  {reservationDisabled(reservation) && reservation?.reservationStatus?.name}

                                  {!reservationDisabled(reservation) && <>
                                    {reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.WALKIN_WAIVER && <>
                                          <span
                                            className={'fa fa-cart-plus'}></span>&nbsp;Complete Reservation

                                    </>
                                    }
                                    {reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.WALKIN_WAIVER && <>
                                      {reservation?.saving ? <span
                                        className={'fa fa-spinner fa-spin'}></span> : <span
                                        className={'fa fa-check'}></span>}
                                      &nbsp;Check{reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN ? 'ed' : ''}&nbsp;In
                                    </>
                                    }
                                  </>
                                  }
                                </MDButton>

        {reservation?.firstTimeGuest && <>
          <Chip
            label={'First Visit'}
            icon={<Icon>star</Icon>}
            color="primary"
            size="medium"
          />&nbsp;
        </>
        }

        <PurchaseEntries reservation={reservation}/>

        {reservation?.specialRequestInput && <>
          <Divider/>
          <b>Party Request:</b>
          <br/>
          {reservation.specialRequestInput}
        </>}
        <ReservationAddons reservation={reservation}/>
                              </span>

        {reservation?.formSubmission &&
          <FormSubmission submission={reservation.formSubmission}/>
        }
      </>
    )
  }

  const ReservationActions = ({reservation, label, index}) => {
    return (
      <>
        {renderIndex && myRefs.current[label + '-' + index]?.visible &&
          <Menu open={true} anchorReference={null}
                className={'no-print'}
                anchorEl={myRefs.current[label + '-' + index]}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}>

            {'noshowReservationsActions' === label &&
              <NotificationItem
                disabled={reservation.cancelling}
                onClick={(e) => {
                  undoCheckinFn(reservation)
                }} icon={<Icon>history</Icon>} title="Undo No-Show"/>
            }

            {'cancelledReservationsActions' === label &&
              <NotificationItem
                disabled={reservation.cancelling}
                onClick={(e) => {
                  undoCheckinFn(reservation)
                }} icon={<Icon>history</Icon>} title="Undo Cancel"/>
            }

            {'noshowReservationsActions' !== label && 'cancelledReservationsActions' !== label &&
              <NotificationItem
                onClick={(e) => {
                  startSearchInventory(reservation)
                }} icon={<Icon>shopping_cart</Icon>} title="Search Add-Ons"/>
            }
            {'checkedInReservationsActions' === label &&
              <NotificationItem
                disabled={reservation.cancelling}
                onClick={(e) => {
                  undoCheckinFn(reservation)
                }} icon={<Icon>history</Icon>} title="Undo Check-In"/>
            }

            <NotificationItem
              onClick={(e) => {
                startMoveReservation(reservation)
              }} icon={<Icon>forward</Icon>} title="Move Reservation"/>

            {'noshowReservationsActions' !== label && 'cancelledReservationsActions' !== label &&
              <NotificationItem
                disabled={reservation.cancelling}
                onClick={(e) => {
                  cancelReservationFn(reservation)
                }} icon={<Icon>cancel</Icon>} title="Cancel Reservation"/>
            }

            {'noshowReservationsActions' !== label &&
              <NotificationItem
                disabled={reservation.cancelling}
                onClick={(e) => {
                  noShowReservationFn(reservation)
                }} icon={<Icon>event_busy</Icon>} title="No-Show"/>
            }

          </Menu>
        }
      </>
    )
  }

  const ReservationAddons = ({reservation}) => {
    return (
      <>
        {reservation?.reservationPurchaseItems?.length > 0 && <div className={'d-block mt-2'}>
          <b>
            Package:
          </b>
          {reservation?.reservationPurchaseItems.sort((a, b) => a.sortOrder - b.sortOrder).map((item, index) => {
            return (
              <span key={index}>
                                          {index === 0 ? '' : ','}&nbsp;{item?.name}
                                        </span>
            )
          })
          }
        </div>
        }

        {reservation?.addOns?.length > 0 && <div className={'d-block mt-2'}>
          <b>
            Add-Ons:&nbsp;
          </b>
          {reservation?.addOns.join(', ')}
        </div>
        }
      </>
    )
  }

  return (
    <DashboardLayout>

      <ContextSearchNavbar title={'View Event' + (isTemplate ? ' Template' : '')}/>
      {!inventoryReady && <PageLoading/>}
      {inventoryReady &&
        <MDBox py={3}>
          <MDBox mb={3}>

            <Grid container spacing={3}>
              <Grid item xs={12} sm={6}>
                <Card>
                  <CardContent>
                    <div className={'pull-right'} ref={el => (myRefs.current['inventoryActions'] = el)}
                         onClick={(e) => {
                           refHandler('inventoryActions')
                         }}>

                      <MDButton
                        variant="outlined"
                        color="secondary"
                        size="small"
                        circular
                        iconOnly
                      >
                        <Icon>more_horiz</Icon>
                      </MDButton>
                      {renderIndex && myRefs.current['inventoryActions']?.visible &&
                        <Menu open={true} anchorReference={null} anchorEl={myRefs.current['inventoryActions']}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}>
                          <NotificationItem
                            onClick={(e) => {
                              handleEditInventory()
                            }} icon={<Icon>edit</Icon>} title="Edit"/>

                          <NotificationItem
                            onClick={(e) => {
                              navigate(`/sales/create/event?fromTemplate=${inventory.guid}`)
                            }} icon={<Icon>copy_all</Icon>} title="Copy"/>

                          {!isTemplate && inventory?.sessionEvent &&
                            <NotificationItem
                              onClick={(e) => {
                                createSessionEvent();
                              }} icon={<Icon>event_repeat</Icon>} title="Create Event in Session"/>}

                          {!isTemplate && inventory?.parentEventGuid &&
                            <NotificationItem
                              onClick={(e) => {
                                handleEditRecurringInventory()
                              }} icon={<Icon>edit_calendar</Icon>}
                              title={inventory?.sessionEvent ? 'Edit Session Series' : 'Edit Recurring Series'}/>}

                          {!isTemplate && publicEventUrl && inventory?.status?.id === CONSTANTS.STATUS.ACTIVE &&
                            <Divider/>
                          }
                          {!isTemplate && publicEventUrl && inventory?.status?.id === CONSTANTS.STATUS.ACTIVE &&
                            <NotificationItem
                              onClick={(e) => {
                                const newWindow = window.open(publicEventUrl, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                              }} icon={<Icon>launch</Icon>} title="View Public Event"/>
                          }

                          {!isTemplate && publicEventUrl && inventory?.status?.id === CONSTANTS.STATUS.ACTIVE &&
                            <NotificationItem
                              onClick={(e) => {
                                copyToClipboard()
                              }} icon={<Icon>copy</Icon>} title="Copy Public Event Link"/>
                          }

                          {!isTemplate && publicEventUrl && inventory?.status?.id === CONSTANTS.STATUS.ACTIVE &&
                            <Divider/>
                          }

                          {!isTemplate && <NotificationItem
                            onClick={(e) => {
                              cancelInventoryEventFn(inventory?.guid)
                            }} icon={<Icon>cancel</Icon>} title="Cancel Event"/>
                          }

                          {isTemplate &&
                            <NotificationItem
                              onClick={(e) => {
                                navigate(`/sales/create/event?fromTemplate=${inventory.guid}`)
                              }} icon={<Icon>event</Icon>} title="Create Event"/>
                          }
                          {isTemplate &&
                            <NotificationItem
                              onClick={(e) => {
                                archiveInventoryEventTemplateFn()
                              }} icon={<Icon>delete</Icon>} title="Archive"/>
                          }

                          {!isTemplate && (inventory?.hasChildren || inventory?.parentEventGuid?.length > 0) &&
                            <NotificationItem
                              onClick={(e) => {
                                cancelAllFutureInventoryEventFn(inventory?.guid)
                              }} icon={<Icon>event_busy</Icon>} title="Cancel Future Events"/>
                          }

                          {!isTemplate && (inventory?.hasChildren || inventory?.parentEventGuid?.length > 0) &&
                            <Divider/>
                          }

                          {!isTemplate && (inventory?.hasChildren || inventory?.parentEventGuid?.length > 0) &&
                            <NotificationItem
                              onClick={(e) => {
                                cancelAllInventoryEventFn(inventory?.parentEventGuid)
                              }} icon={<Icon>delete_forever</Icon>} title="Cancel All Events"/>
                          }

                        </Menu>
                      }
                    </div>
                    {inventory?.name &&
                      <>
                        <h4 className={'mt-2'}>
                          {inventoryNotes && clientFlags(inventoryNotes) ? <>
                            <MDButton
                              className={"pull-left"}
                              variant="contained"
                              color="info"
                              size="small"
                              circular
                              iconOnly
                              onClick={() => {
                                toggleFlags()
                              }}
                            >
                              <span className={'fa fa-flag'}></span>
                            </MDButton>&nbsp;
                          </> : <></>}{inventory?.name}
                        </h4>


                        {inventory?.sessionEvent &&
                          <h6>
                            <Icon
                              className={'ml-n2'} color={'info'}>event_repeat</Icon>Session Event
                          </h6>}
                        {inventory?.eventLocation?.id > -1 && <>
                          <h6>
                            <Icon className={'ml-n2'} color={'success'}>place</Icon>
                            {inventory?.eventLocation?.name}
                            {inventory?.eventLocation?.address ? ' - ' : ''}
                            {inventory?.eventLocation?.address}

                            {inventory?.bookedSibling ? <p><Icon>lightbulb</Icon>&nbsp;Location Booked</p> : <></>}

                          </h6>
                        </>
                        }
                      </>
                    }

                    <Row>
                      <Col sm={6}>
                        <h6>Inventory Type</h6>
                        <p>{inventory?.inventoryType?.name}</p>

                        <h6>Event Type</h6>
                        <p>{inventory?.eventType?.name}</p>

                        <h6>Available</h6>
                        <p>
                          {inventoryAvailable(inventory)}
                        </p>
                      </Col>
                      <Col sm={6}>
                        <h6>Age</h6>
                        <p>
                          {inventory?.ageRange?.name || 'General'}
                        </p>

                        <h6>Length</h6>
                        <p>
                          {displayDuration(inventory)}
                        </p>
                        <h6>{inventory?.sessionEvent ? 'Session ' : ''}Price</h6>

                        <p>{inventory?.eventMatrix ? ('Matrix - ' + inventory?.eventMatrix?.name) : formatCurrency(inventory?.price)}</p>

                      </Col>
                    </Row>


                    {inventory?.eventMatrix && <Row>
                      <Col xs={12}>
                        {inventory?.eventMatrix?.entries?.length > 0 && <div>
                          <p><b>Event Matrix Entries</b></p>
                          <div>
                            {inventory?.eventMatrix.entries?.sort((a, b) => a.id - b.id).map((entry, idx) => {
                              return (
                                <span key={idx}>
                                              <Chip className={'mt-1'}
                                                    label={(formatCurrency(entry.price)) + ' ' + (entry?.adult ? 'Adult' : displayAgeRange(entry))}
                                                    icon={<Icon>person</Icon>}
                                                    color="primary"
                                                    variant="outlined"
                                                    size="medium"
                                              />&nbsp;
                                          </span>
                              )
                            })}

                          </div>
                        </div>
                        }
                      </Col>
                    </Row>
                    }


                    <Row className={'mt-2'}>
                      <Col sm={12}>
                        {isTemplate && <>
                          <Chip
                            size="small"
                            className={'mb-1'}
                            label="Template"
                            variant="outlined"
                            color="info"
                          />&nbsp;
                        </>}
                        <Chip
                          size="small"
                          className={'mb-1'}
                          label={inventory?.status?.name}
                          variant="outlined"
                        />&nbsp;
                        {inventory?.eventType?.privateAccess &&
                          <Chip
                            size="small"
                            className={'mb-1'}
                            label="Private"
                            color="info"/>
                        }

                        {inventory?.eventType?.specialEvent &&
                          <Chip
                            size="small"
                            className={'mb-1'}
                            label="Party Event"
                            color="success"/>
                        }
                      </Col>

                    </Row>
                    <Divider/>
                    <h6>Date</h6>
                    <p>
                      {inventory?.allDay && formatDateMask(inventory?.eventDate, 'MM/DD/yyyy')}
                      {!inventory?.allDay && <>
                        {formatDateTime(inventory?.eventDate)} - {displayDay(inventory?.eventEndDate, 'hh:mm a')}
                      </>
                      }
                    </p>

                    {inventory?.sessionEvents?.length > 0 && <>
                      <b>Session Events</b>
                      {inventory?.sessionEvents?.length > 0 && inventory?.sessionEvents?.sort((a, b) => new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime())
                        .map((event, key) => {
                          return (<li className={'list-group-item'} key={key}>
                            <Link
                              to={'/event/view/' + event.guid}>{event.name} - {formatDateTime(event.eventDate)}</Link>
                          </li>)
                        })
                      }
                    </>}

                    <h6>Description</h6>
                    <p style={{
                      whiteSpace: 'pre-wrap',
                      marginLeft: '2px',
                      paddingLeft: '8px',
                      borderLeft: 'solid 2px #ddd'
                    }}>{inventory?.desc}</p>
                    <Divider/>
                    <Row>
                      <Col sm={12}>
                        <b className={'d-block'}>Public Image</b>
                        {inventory?.imageUrl && <img
                          className={'mt-2 img-thumbnail'} src={inventory?.imageUrl} alt="img"/>}
                      </Col>
                    </Row>
                  </CardContent>
                </Card>
              </Grid>

              {!isTemplate && <Grid item xs={12} sm={6}>
                <Card>
                  <CardContent>
                    <MDButton
                      color="secondary"
                      size="small"
                      className={'pull-right'}
                      disabled={inventory?.status?.id === CONSTANTS.STATUS.INACTIVE || inventoryAvailable(inventory) <= 0}
                      onClick={(e) => {
                        e.preventDefault();
                        startAddCustomerReservation();
                      }}>
                      <span className={'fa fa-user-plus'}></span>&nbsp;Add
                    </MDButton>

                    <h5>
                      Reservations
                    </h5>
                    <Divider/>

                    {client &&
                      <p>Last Customer - <a href={`/client/${client.guid}`}>{client.firstName} {client.lastName}</a>
                      </p>}
                    <Row>
                      <Col sm={12}>

                        <Grid container spacing={2}>
                          <Grid item xs={10}>
                            <ButtonGroup className={'mb-2'}
                                         variant="outlined"
                                         size="small"
                                         aria-label="Event Reservations">

                              <Button
                                size="small"
                                key={'active'}
                                style={{
                                  color: reservationTabActive === 'active' ? '#fff' : '#111',
                                  background: reservationTabActive === 'active' ? '#111' : '#fff',
                                  borderColor: '#111'
                                }}
                                onClick={(e) => {
                                  setReservationTabActive('active')
                                }}>
                                Booked {bookedReservations > 0 && `(${bookedReservations})`}
                              </Button>
                              <Button
                                size="small"
                                style={{
                                  color: reservationTabActive === 'checkedin' ? '#fff' : '#111',
                                  background: reservationTabActive === 'checkedin' ? '#111' : '#fff',
                                  borderColor: '#111'
                                }}
                                key={'checkedin'}
                                onClick={(e) => {
                                  setReservationTabActive('checkedin')
                                }}>
                                Checked In {checkedInReservations > 0 && `(${checkedInReservations})`}
                              </Button>
                              <Button
                                style={{
                                  color: reservationTabActive === 'cancelled' ? '#fff' : '#111',
                                  background: reservationTabActive === 'cancelled' ? '#111' : '#fff',
                                  borderColor: '#111'
                                }}
                                size="small"
                                key={'cancelled'}
                                onClick={(e) => {
                                  setReservationTabActive('cancelled')
                                }}>
                                Cancelled {cancelledReservations > 0 && `(${cancelledReservations})`}
                              </Button>
                              <Button
                                style={{
                                  color: reservationTabActive === 'noshow' ? '#fff' : '#111',
                                  background: reservationTabActive === 'noshow' ? '#111' : '#fff',
                                  borderColor: '#111'
                                }}
                                size="small"
                                key={'noshow'}
                                onClick={(e) => {
                                  setReservationTabActive('noshow')
                                }}>
                                No-Show {noShowReservations > 0 && `(${noShowReservations})`}
                              </Button>

                            </ButtonGroup>
                          </Grid>
                          <Grid item xs={2}>

                            <ButtonGroup>

                              <MDButton
                                variant="outlined"
                                color="secondary"
                                size="small"
                                circular
                                iconOnly
                                ref={el => (myRefs.current['massActions'] = el)}
                                onClick={() => {
                                  refHandler('massActions')
                                }}
                              >
                                <Icon>expand_more</Icon>
                              </MDButton>

                              <MDButton
                                variant="outlined"
                                color="secondary"
                                size="small"
                                circular
                                iconOnly
                                onClick={() => {
                                  printReservationTab()
                                }}
                              >
                                <Icon>print</Icon>
                              </MDButton>

                            </ButtonGroup>

                            {renderIndex && myRefs.current['massActions']?.visible &&

                              <Menu open={myRefs.current['massActions']?.visible} anchorReference={null}
                                    anchorEl={myRefs.current['massActions']}
                                    onClose={(event, reason) => {
                                      refHandler('massActions')
                                    }}
                                    anchorOrigin={{
                                      vertical: "bottom",
                                      horizontal: "left",
                                    }}>

                                <NotificationItem
                                  onClick={(e) => {
                                    startComposeEmail();
                                    refHandler('massActions');
                                  }} icon={<Icon>email</Icon>} title="Compose Email"/>

                                <NotificationItem
                                  onClick={(e) => {
                                    startAddTags();
                                    refHandler('massActions');
                                  }} icon={<Icon>label_important</Icon>} title="Add Tags"/>

                              </Menu>
                            }

                          </Grid>
                        </Grid>


                        {reservationTabActive === 'active' &&
                          <ul className={'list-group'} id={'reservation-tab-active'}>
                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CHECKED_IN && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CANCELLED && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.NO_SHOW)?.length === 0 &&
                              <li className={'list-group-item'}>
                                <center>No active reservations for this event</center>
                              </li>
                            }
                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CHECKED_IN && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.CANCELLED && reservation?.reservationStatus?.id !== CONSTANTS.RESERVATION_STATUS.NO_SHOW)?.map((reservation, index) => {
                              return (<li key={index} className={'list-group-item'}>
                                  <h6>
                                    <ActiveMember client={reservation.member}/>
                                    <Link to={'/client/' + reservation?.member?.guid}>
                                      <DisplayAttendee reservation={reservation}/>
                                    </Link>

                                    <div className={'pull-right'}
                                         ref={el => (myRefs.current['reservationsActions-' + index] = el)}
                                         onClick={(e) => {
                                           refHandler('reservationsActions-' + index)
                                         }}>
                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>
                                      <ReservationActions reservation={reservation} label={'reservationsActions'}
                                                          index={index}/>
                                    </div>
                                  </h6>

                                  <ReservationMeta reservation={reservation}/>

                                </li>
                              )
                            })}
                          </ul>
                        }

                        {reservationTabActive === 'checkedin' &&
                          <ul className={'list-group'} id={'reservation-tab-checkedin'}>
                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN)?.length === 0 &&
                              <li className={'list-group-item'}>
                                <center>No reservations checked in for this event</center>
                              </li>
                            }
                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CHECKED_IN)?.map((reservation, index) => {
                              return (<li key={index} className={'list-group-item'}>
                                  <h6>
                                    <ActiveMember client={reservation.member}/>
                                    <Link to={'/client/' + reservation?.member?.guid}>
                                      <DisplayAttendee reservation={reservation}/>
                                    </Link>

                                    <div className={'pull-right'}
                                         ref={el => (myRefs.current['checkedInReservationsActions-' + index] = el)}
                                         onClick={(e) => {
                                           refHandler('checkedInReservationsActions-' + index)
                                         }}>
                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>

                                      <ReservationActions reservation={reservation}
                                                          label={'checkedInReservationsActions'} index={index}/>

                                    </div>
                                  </h6>

                                  <ReservationMeta reservation={reservation}/>

                                </li>
                              )
                            })}
                          </ul>
                        }
                        {reservationTabActive === 'cancelled' &&
                          <ul className={'list-group'} id={'reservation-tab-cancelled'}>

                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CANCELLED)?.length === 0 &&
                              <li className={'list-group-item'}>
                                <center>No cancelled reservations for this event</center>
                              </li>
                            }
                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.CANCELLED)?.map((reservation, index) => {
                              return (<li key={index} className={'list-group-item'}>
                                  <h6>
                                    <ActiveMember client={reservation.member}/>
                                    <Link to={'/client/' + reservation?.member?.guid}>
                                      <DisplayAttendee reservation={reservation}/>
                                    </Link>

                                    <div className={'pull-right'}
                                         ref={el => (myRefs.current['cancelledReservationsActions-' + index] = el)}
                                         onClick={(e) => {
                                           refHandler('cancelledReservationsActions-' + index)
                                         }}>
                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>
                                      <ReservationActions reservation={reservation}
                                                          label={'cancelledReservationsActions'} index={index}/>
                                    </div>

                                  </h6>

                                  <ReservationMeta reservation={reservation}/>

                                  <Audit auditCreateUser={reservation} auditModifyUser={reservation}/>

                                </li>
                              )
                            })}
                          </ul>
                        }

                        {reservationTabActive === 'noshow' &&
                          <ul className={'list-group'} id={'reservation-tab-noshow'}>

                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.NO_SHOW)?.length === 0 &&
                              <li className={'list-group-item'}>
                                <center>No no show reservations for this event</center>
                              </li>
                            }
                            {inventory?.reservations && inventory?.reservations?.sort((a, b) => a.id > b.id ? 1 : -1)?.filter((reservation) => reservation?.reservationStatus?.id === CONSTANTS.RESERVATION_STATUS.NO_SHOW)?.map((reservation, index) => {
                              return (<li key={index} className={'list-group-item'}>
                                  <h6>
                                    <ActiveMember client={reservation.member}/>
                                    <Link to={'/client/' + reservation?.member?.guid}>
                                      <DisplayAttendee reservation={reservation}/>
                                    </Link>

                                    <div className={'pull-right'}
                                         ref={el => (myRefs.current['noshowReservationsActions-' + index] = el)}
                                         onClick={(e) => {
                                           refHandler('noshowReservationsActions-' + index)
                                         }}>
                                      <MDButton
                                        variant="outlined"
                                        color="secondary"
                                        size="small"
                                        circular
                                        iconOnly
                                      >
                                        <Icon>more_horiz</Icon>
                                      </MDButton>
                                      <ReservationActions reservation={reservation}
                                                          label={'noshowReservationsActions'} index={index}/>

                                    </div>

                                  </h6>

                                  <ReservationMeta reservation={reservation}/>

                                </li>
                              )
                            })}
                          </ul>
                        }

                      </Col>
                    </Row>
                  </CardContent>
                </Card>

                {inventory?.eventType?.guestWaiverGk &&
                  <>
                    <div>&nbsp;</div>
                    <EventGuests
                      inventory={inventory}
                      callback={(type) => {
                        if ('reload' === type) {
                          setRefreshEvent(true);
                        }
                      }}
                    />
                  </>
                }

                {!inventory.eventType?.disableWaitlist && <Card style={{
                  'marginTop': '20px'
                }}>
                  <CardContent>

                    <h5>
                      Wait List
                      <ButtonGroup className={'pull-right'}>
                        <MDButton
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                          onClick={(e) => {
                            e.preventDefault();
                            startAddCustomerWaitlist();
                          }}>
                          <span className={'fa fa-user-plus'}></span>
                        </MDButton>

                        <MDButton
                          variant="outlined"
                          color="secondary"
                          size="small"
                          circular
                          iconOnly
                          ref={el => (myRefs.current['massActionsWaitlist'] = el)}
                          onClick={() => {
                            refHandler('massActionsWaitlist')
                          }}
                        >
                          <Icon>expand_more</Icon>
                        </MDButton>
                      </ButtonGroup>

                      {renderIndex && myRefs.current['massActionsWaitlist']?.visible &&

                        <Menu open={myRefs.current['massActionsWaitlist']?.visible} anchorReference={null}
                              anchorEl={myRefs.current['massActionsWaitlist']}
                              onClose={(event, reason) => {
                                refHandler('massActionsWaitlist')
                              }}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}>

                          <NotificationItem
                            onClick={(e) => {
                              startComposeWaitlistEmail();
                              refHandler('massActionsWaitlist');
                            }} icon={<Icon>email</Icon>} title="Compose Email"/>

                          <NotificationItem
                            onClick={(e) => {
                              startWaitlistAddTags();
                              refHandler('massActionsWaitlist');
                            }} icon={<Icon>label_important</Icon>} title="Add Tags"/>

                        </Menu>
                      }

                    </h5>
                    <Divider/>
                    <Row>
                      <Col sm={12}>
                        <ul className={'list-group'}>
                          {inventory?.waitlist && inventory?.waitlist.sort((a, b) => a.id > b.id ? 1 : -1).map((waitlist, index) => {
                            return (<li key={index} className={'list-group-item'}>
                                <MDTypography fontWeight={'regular'}
                                              variant={'h6'}>
                                  {waitlist?.member && <ActiveMember client={waitlist.member}/>} <Link
                                  to={'/client/' + waitlist?.member?.guid}>
                                  {waitlist?.member?.firstName}&nbsp;{waitlist?.member?.lastName}
                                </Link>

                                  <div className={'pull-right'}
                                       ref={el => (myRefs.current['waitlistActions-' + index] = el)}
                                       onClick={(e) => {
                                         refHandler('waitlistActions-' + index)
                                       }}>
                                    <MDButton
                                      variant="outlined"
                                      color="secondary"
                                      size="small"
                                      circular
                                      iconOnly
                                    >
                                      <Icon>more_horiz</Icon>
                                    </MDButton>
                                    {renderIndex && myRefs.current['waitlistActions-' + index]?.visible &&
                                      <Menu open={true} anchorReference={null}
                                            anchorEl={myRefs.current['waitlistActions-' + index]}
                                            anchorOrigin={{
                                              vertical: "bottom",
                                              horizontal: "left",
                                            }}>

                                        <NotificationItem
                                          disabled={waitlist.saving}
                                          onClick={(e) => {
                                            confirmEventWaitlistRegistration(waitlist)
                                          }} icon={<Icon>person_outline</Icon>} title="Confirm Event Registration"/>

                                        <NotificationItem
                                          disabled={waitlist.cancelling}
                                          onClick={(e) => {
                                            cancelWaitlistFn(waitlist)
                                          }} icon={<Icon>cancel</Icon>} title="Cancel Wait List"/>

                                      </Menu>
                                    }
                                  </div>
                                </MDTypography>

                                <span style={{
                                  'clear': 'both',
                                  'display': 'block',
                                  'marginTop': '10px',
                                  'paddingBottom': '10px'
                                }}>
                                <MDButton
                                  color={'info'}
                                  size="small"
                                  className={'pull-right'}
                                  disabled={waitlist?.saving}
                                  onClick={(e) => {
                                    confirmEventWaitlistRegistration(waitlist)
                                  }}>
                                  {!waitlist.saving ? <><span
                                      className={'fa fa-check'}></span>&nbsp;Join</>
                                    : <><span
                                      className={'fa fa-spinner fa-spin'}></span>&nbsp;Joining</>}
                                </MDButton>
                                <Chip variant="outlined"
                                      avatar={<Avatar><span
                                        className={waitlist?.waitlistStatus?.id === CONSTANTS.RESERVATION_STATUS.PENDING ? 'fa fa-bookmark-O' : 'fa fa-bookmark'}></span></Avatar>}
                                      label={waitlist?.waitlistStatus?.name}/>
                              </span>
                              </li>
                            )
                          })}
                        </ul>
                      </Col>
                    </Row>
                  </CardContent>
                </Card>
                }

              </Grid>
              }
            </Grid>

            {!isTemplate && <Card className={'mt-4'}>
              <CardContent>
                <h5>
                  Event Notes
                  <MDButton
                    color="secondary"
                    size="small"
                    disabled={clientDisabled}
                    className={'pull-right'}
                    onClick={addNoteFn}>
                    <span className={'fa fa-plus'}></span>&nbsp;Add note
                  </MDButton>
                  <input type={'text'} className={'form-control form-control-sm my-n1 mx-2 pull-right w-25'}
                         placeholder={'Search Notes'}
                         onFocus={(e) => {
                           setModalActive(true);
                         }}
                         onBlur={(e) => {
                           setModalActive(false);
                         }}
                         onChange={(e) => {
                           setSearchNotes(e.target.value);
                         }}/>
                </h5>
                <Divider/>
                <Row style={{
                  'clear': 'both',
                  'maxHeight': '500px',
                  'overflow': 'auto'
                }}>
                  <Col sm={12}>

                    <ul className={'list-group'}>
                      {inventoryNotes?.length === 0 && <li className={'list-group-item'}>
                        <center>No customer notes</center>
                      </li>
                      }

                      {inventoryNotes?.sort((a, b) => a.createDate - b.createDate).filter((a) => a.pinned).map((note, index) => {
                          return (
                            <NoteItem note={note} key={index} index={index}/>
                          )
                        }
                      )}

                      {inventoryNotes?.sort((a, b) => a.createDate - b.createDate).filter((a) => !!!a.pinned).map((note, index) => {
                          return (
                            <NoteItem note={note} key={index} index={index}/>
                          )
                        }
                      )}
                    </ul>

                  </Col>
                </Row>
              </CardContent>
            </Card>
            }

          </MDBox>
        </MDBox>
      }
      <ListCustomersModal show={listCustomersModalOpen}
                          embedded={true}
                          action={handleAssignInventory}
                          actionLabel={'Register'}
                          handleCloseListCustomersModal={handleCloseListCustomersModal}/>

      <ListCustomersModal show={listCustomersWaitlistModalOpen}
                          embedded={true}
                          action={handleAssignWaitlist}
                          actionLabel={'Join Wait List'}
                          handleCloseListCustomersModal={handleCloseListWaitlistCustomersModal}/>

      {
        (addNote || manageNote) && <EventNoteModal
          key={note?.guid}
          note={note}
          show={manageNote || addNote}
          saving={saving}
          handleClose={handleCloseNote}
          handleSave={handleSaveNote}/>
      }

      {showFlags && <NoteFlagsModal
        notes={inventoryNotes}
        show={showFlags}
        handleClose={() => {
          setShowFlags(false)
        }}
      />}


      {
        confirmation && showCancelEvent && <Confirm loading={cancelActing}
                                                    confirmation={confirmation}
                                                    show={showCancelEvent}
                                                    saving={savingCancelEvent}
                                                    handleSave={handleCloseConfirm}
                                                    handleConfirm={handleCancelSwitch}/>
      }

      {
        showMoveRegistration && reservation && <ClientLookupEventsModal
          show={true}
          reservation={reservation}
          hideDesc={true}
          client={client}
          saving={saving}
          handleClose={() => {
            setShowMoveRegistration(false)
          }}
          handleSave={(d) => {
            handleMoveReservation(d);
          }}/>
      }

      {
        showRegistrationInventory && reservation && <ClientViewEventRegistrationModal
          show={showRegistrationInventory}
          saving={saving}
          reservation={reservation}
          handleClose={toggleReservationsCartFn}
          toggleCheckout={toggleCheckout}
          handleSave={handleCheckout}/>
      }

      {
        cartActive && client && <CartFinal
          client={client}
          cartActive={cartActive}
          callback={cartCallback}
          client={client}
        />
      }

      {
        client && <ClientViewCustomerCartModal
          show={viewingCart}
          client={client}
          saving={saving}
          handleCartRefresh={() => {
            setRefreshCart(true);
          }}
          reservation={reservation}
          handleClose={toggleCartFn}
          handleSave={handleCheckout}/>
      }

      {
        modalInventory && <ManageInventoryEventModal
          refresh={true}
          inventory={modalInventory}
          show={manageInventoryEvent}
          saving={saving}
          handleSave={handleSaveInventory}
          handleClose={handleCloseInventoryEventModal}/>
      }

      {
        sessionEventInventory && <ManageInventoryEventModal
          refresh={true}
          inventory={sessionEventInventory}
          show={manageInventorySessionEvent}
          saving={saving}
          handleClose={() => {
            setManageInventorySessionEvent(false)
          }}/>
      }


      {actionItemActive && <ActionItem actionType={actionItem} key={actionItem}
                                       actionUsers={actionRecipients}
                                       callback={() => {
                                         setActionItemActive(false);
                                       }}
      />
      }
      {
        showRegisterEvent && <RegisterEventModal
          handleClose={() => {
            setShowRegisterEvent(false)
          }}
          successCallback={() => {
            setShowRegisterEvent(false);
            viewCustomerCart();
          }}
          client={client}
          show={showRegisterEvent}
          event={inventory}
        />
      }

      {
        confirmation && confirmDeleteNote && <Confirm confirmation={confirmation}
                                                      show={confirmDeleteNote}
                                                      saving={saving}
                                                      handleConfirm={handleConfirmDeleteNote}
                                                      handleSave={() => {
                                                        setConfirmation(null);
                                                        setConfirmDeleteNote(false);
                                                      }}/>
      }


      {
        publicEventUrl && <textarea id="copyElement" defaultValue={publicEventUrl}
                                    style={{
                                      visibility: 'hidden',
                                      position: 'absolute',
                                      left: '-999em',
                                      height: 0,
                                      width: 0
                                    }}
        />
      }

      <Footer mt={5}/>
    </DashboardLayout>
  )
    ;
}